import { adapterHelper } from '../utils/clinicianSearch/send-all-catalog';
import ApplicationAdapter from './application';

export default class Clinician extends ApplicationAdapter {
  urlForQuery(query, modelName) {
    let url = adapterHelper(this, query);
    return url ?? super.urlForQuery(query, modelName);
  }
}
